import type { FC } from 'react'

import type { RibbonItemsText } from '../../types'
import css from './ProjectToolbar.css'
import { defaultItems, seismicInterpretationItems } from './RibbonItems'
import { ToolbarItem } from './ToolbarItem'

type Props = {
  getActionFromRibbonItem: (arg: RibbonItemsText) => void
  selectedRibbonItem?: RibbonItemsText
  setSelectedRibbonItem: (arg: RibbonItemsText) => void
}

export const RibbonPanel: FC<Props> = ({
  getActionFromRibbonItem,
  selectedRibbonItem,
  setSelectedRibbonItem,
}) => {
  return (
    <div className={css.toolbarRibbon}>
      <div className={css.toolbarRibbonScroll}>
        {defaultItems.map(item => (
          <ToolbarItem
            key={item.text}
            item={item}
            selectedRibbonItem={selectedRibbonItem}
            setSelectedRibbonItem={setSelectedRibbonItem}
            getActionFromRibbonItem={getActionFromRibbonItem}
          />
        ))}
        <div className={css.interpretationList}>
          {seismicInterpretationItems.map(item => (
            <ToolbarItem
              key={item.text}
              item={item}
              selectedRibbonItem={selectedRibbonItem}
              setSelectedRibbonItem={setSelectedRibbonItem}
              getActionFromRibbonItem={getActionFromRibbonItem}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
